/** Avatar (06 §4.13) — image when available else deterministic-color initials. */
import { colorForId, initials } from '../../lib/format';
import styles from './Avatar.module.css';

interface AvatarProps {
  id: string;
  name: string;
  url?: string | null;
  size?: number;
  /** Optional online dot overlay. */
  online?: boolean;
}

export function Avatar({ id, name, url, size = 49, online }: AvatarProps) {
  return (
    <span
      className={styles.avatar}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {url ? (
        <img src={url} alt={name} className={styles.img} loading="lazy" />
      ) : (
        <span
          className={styles.fallback}
          style={{ background: colorForId(id) }}
          aria-label={name}
        >
          {initials(name)}
        </span>
      )}
      {online && <span className={styles.dot} aria-hidden="true" />}
    </span>
  );
}
